﻿export interface IDutyOfficerScheduleRequest {
    id: number;
    dayId: number;
    startTime: string;
    endTime: string;
    officerId: number;
}
